import type { DividedCollapsedContacts } from './collapse-contacts';
import type { WithCollapsedContact, WithCollapsedMemberContact } from './contacts';
import { toCollapsedContact } from './contacts';

export function collapseByMemberEmail(
  dividedContacts: DividedCollapsedContacts
): DividedCollapsedContacts {
  const { members, authContacts, authResourceContacts, userContacts, unknownContacts } = dividedContacts;

  const memberMap = new Map<string, WithCollapsedMemberContact>();

  for (const member of members) {
    memberMap.set(member.email.toLowerCase(), member);
  }

  function moveToMemberCollapsed(contact: WithCollapsedContact) {
    const emailKey = contact.email.toLowerCase();
    const member = memberMap.get(emailKey);
    if (member) {
      member.collapsedContacts.push(...contact.collapsedContacts, toCollapsedContact(contact));
    }
  }

  const filteredAuthContacts = authContacts.filter((auth) => {
    const shouldCollapse = memberMap.has(auth.email.toLowerCase());
    if (shouldCollapse) {
      moveToMemberCollapsed(auth);
    }
    return !shouldCollapse;
  });

  const filteredAuthResourceContacts = authResourceContacts.filter((resource) => {
    const shouldCollapse = memberMap.has(resource.email.toLowerCase());
    if (shouldCollapse) {
      moveToMemberCollapsed(resource);
    }
    return !shouldCollapse;
  });

  const filteredUserContacts = userContacts.filter((user) => {
    const shouldCollapse = memberMap.has(user.email.toLowerCase());
    if (shouldCollapse) {
      moveToMemberCollapsed(user);
    }
    return !shouldCollapse;
  });

  return {
    members,
    authContacts: filteredAuthContacts,
    authResourceContacts: filteredAuthResourceContacts,
    userContacts: filteredUserContacts,
    unknownContacts
  };
}
